// Wrapper type-safe autour de window.umami (injecté par le script Umami dans index.html)
declare global {
  interface Window {
    umami?: {
      track: (eventName: string, data?: Record<string, unknown>) => void;
    };
  }
}

/**
 * Envoie un événement personnalisé à Umami.
 * Sans effet si le script Umami n'est pas chargé (env vars non définies).
 */
export const track = (eventName: string, data?: Record<string, unknown>): void => {
  window.umami?.track(eventName, data);
};
